import { assign, createMachine, fromPromise } from 'xstate'

import Api from '@/api/_legacy'
import { ApiNewDfm } from '@/api/_legacy/generated-api'

import { setErrorsAction } from '../../common/set-errors-action'
import { Mutation } from '../../types'

const TENANT_ID = 'absa'

export type AddDfmState = {
  dfm: { dfmName: string }
  errorMessages: string[]
  errors: { [key: string]: string }
  isSaveEnabled: boolean
  isSaveSuccess: boolean
  onSaveSuccess?: () => void
}

type MutateEvent = {
  mutation: Mutation<ApiNewDfm>
  type: 'MUTATE'
}

type SaveEvent = {
  dfm: ApiNewDfm
  type: 'SAVE'
}

export type AddDfmEvent = MutateEvent | SaveEvent

export const addDfmMachine = createMachine(
  {
    types: {} as {
      context: AddDfmState
      events: AddDfmEvent
    },
    id: 'add-dfm-machine',
    initial: 'idle',
    context: {
      dfm: {
        dfmName: ''
      },
      isSaveSuccess: false,
      isSaveEnabled: false,
      errors: {},
      errorMessages: []
    },
    states: {
      idle: {
        on: {
          MUTATE: {
            actions: ['mutate', 'setDirty'],
            target: 'idle'
          },
          SAVE: 'saving'
        }
      },
      saving: {
        invoke: {
          id: 'saveDfm',
          src: 'saveDfm',
          input: ({ context, event }) => ({ context, event }),
          onDone: {
            actions: ['clearErrors'],
            target: 'saveSuccess'
          },
          onError: {
            actions: ['setError'],
            target: 'idle'
          }
        }
      },
      saveSuccess: {}
    }
  },
  {
    actors: {
      saveDfm: fromPromise(async ({ input }: any) => {
        const dfm = input.event.dfm as ApiNewDfm

        if (dfm.dfmName.length < 1) {
          throw {
            type: 'validation',
            errors: {
              dfmName: 'Dfm name must be supplied'
            }
          }
        }

        const response = await Api.tenant.postTenant2(TENANT_ID, dfm)
        const { data } = response
        return data
      })
    },
    actions: {
      mutate: assign(({ context, event }: any) => {
        const dfm = { ...context.dfm }
        event.mutation(dfm)

        return {
          ...context,
          dfm
        }
      }),
      setDirty: assign(context => ({
        ...context,
        isSaveEnabled: true
      })),
      setError: assign(({ context, event }: any) => setErrorsAction(context, event)),
      clearErrors: assign(context => ({
        ...context,
        errors: {}
      }))
    }
  }
)
